






























/** @format */

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { API_SERVER } from '@root/common/config';
import { uploadImage } from '@/api/upload';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
// 文件上传状态
enum UploadStatus {
  UPLOADING = 'uploading', // 上传中
  DONE = 'done', // 完成上传
  ERROR = 'error', // 上传出现错误
  REMOVED = 'removed' // 文件已移除
}

// 文件信息
interface IFileInfo {
  uid: string; // 文件唯一标识
  name: string; // 文件名称
  status: UploadStatus; // 文件上传状态
  url: string; // 文件在线地址
  thumbUrl?: string; // 文件缩略图地址
  lastModified?: number; // 最近修改时间戳
  lastModifiedDate?: Date; // 最近修改日期
  size?: number; // 文件大小
  type?: string; // 文件类型
  percent?: number; // 文件上传进度
  response?: string; // 服务器响应内容
  filePath?: string; //需要传给后端的参数
}

@Component
export default class ImageUpload extends Vue {
  // text, picture 和 picture-card
  @Prop({ default: 'picture-card' })
  private listType!: string;
  // 默认已上传文件列表
  @Prop({ default: () => [] })
  initImageUrls!: string[];
  // 是否允许多选
  @Prop({ default: false })
  multiple!: boolean;
  // 默认已上传文件列表
  @Prop({ default: () => [] })
  defaultFileList!: IFileInfo[];
  // 车场id
  @Prop({ default: '' })
  parkId!: string;
  // 最多上传的文件数
  @Prop({ default: 3 })
  showCount!: Number;
  //是否禁用
  @Prop({ default: false })
  disabled!: boolean;
  //默认文件大小
  @Prop({ default: 2 })
  fileSize!: Number;
  //上传文件所需字段
  @Prop({ default: '00' })
  private fileType!: string;
  //是否需要上传parkId
  @Prop({ default: true })
  private needParkId?: boolean;
  //是否上传完毕
  uploading: boolean = false;
  // 上传文件地址
  actions: string = `${API_SERVER.default}/bangdao/saasapi/v1/image/upload`;
  // 上传所需参数
  extraData: {
    [key: string]: any;
  } = {};

  headers: any = {};
  previewVisible: boolean = false;
  previewImage: string = '';
  fileList: any = [];
  completeFileList: any[] = [];
  locale = zhCN;
  mounted() {
    console.log('img===>1', this.initImageUrls);
    this.$nextTick(() => {
      console.log('img===>2', this.initImageUrls);
      this.fileList = this.initImageUrls.map((item, index) => {
        return {
          uid: (index + 1) * -1,
          name: item.match(new RegExp('.+/(.+)$'))[1],
          status: UploadStatus.DONE,
          url: `${API_SERVER.imgBaseUrl}${item}`,
          filePath: item
        };
      });
    });
  }
  //回填文件
  initList() {
    this.$nextTick(() => {
      this.fileList = this.initImageUrls.map((item, index) => {
        return {
          uid: (index + 1) * -1,
          name: item.match(new RegExp('.+/(.+)$'))[1],
          status: UploadStatus.DONE,
          url: `${API_SERVER.imgBaseUrl}${item}`,
          filePath: item
        };
      });
    });
  }

  /**
   * 文件上传前
   * @param file 上传的文件
   * @param fileList
   */
  async handleBeforeUpload(file: IFileInfo, fileList: IFileInfo[]) {
    try {
      const pos = file.name.lastIndexOf('.');
      let suffix = '';
      if (pos !== -1) suffix = file.name.substring(pos + 1);
      // let fileBase64 = await getBase64(file)
      // this.extraData = {
      //   parkId: this.parkId,
      //   fileName: file.name,
      //   fileType: '00',
      //   fileBase64: fileBase64,
      // }
      // let token = localCache.get('token')
      // if (token) {
      //   this.headers['Authorization'] = 'Bearer ' + token
      // }
      // this.actions = `${API_SERVER.default}/bangdao/saasapi/v1/image/upload`
      //手动设置文件在线地址
      //file.url = `${this.action}${key}`
    } catch (error) {
      this.$message.error('文件上传失败');
    }
  }

  async handlePreview(file) {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.previewImage = file.url || file.preview;
    console.log(this.previewImage);
    this.previewVisible = true;
  }
  handlePreviewCancel() {
    this.previewVisible = false;
  }

  /**
   * 上传中、完成、失败都会调用这个函数
   * file 当前操作的文件对象
   * fileList 当前的文件列表
   * event 上传中的服务端响应内容，包含了上传进度等信息
   * @param info: {file, fileList, event}
   */
  handleChange({ file, fileList, event }: { file: IFileInfo; fileList: IFileInfo[]; event: any }) {
    if (fileList.length < this.fileList.length) {
      console.log('删除');
      this.fileList = fileList;
      this.$emit('on-file-change', fileList);
      const findUndoneIndex = fileList.findIndex(file => file.status !== UploadStatus.DONE);
      //const fileUrls = fileList.map(file => file.url)
      const fileUrls = fileList.map(file => file.filePath || '');
      if (findUndoneIndex === -1) {
        this.$emit('complete', fileUrls);
      }
    } else {
      console.log('新增');
    }
  }

  async customRequest(uploadData) {
    try {
      if (this.needParkId) {
        if (!this.parkId) return this.$message.error('请先选择车场');
      }
      const isJpgOrPng = uploadData.file.type === 'image/jpeg' || uploadData.file.type === 'image/png';
      if (!isJpgOrPng) {
        return this.$message.error('只能上传png,jpg格式的图片');
      }
      console.log('uploadData--', uploadData);
      const isLt2M = uploadData.file.size / 1024 / 1024 < this.fileSize;
      if (!isLt2M) {
        return this.$message.error(`图片应小于${this.fileSize}M`);
      }
      if (this.uploading) return;
      this.uploading = true;
      const pos = uploadData.file.name.lastIndexOf('.');
      let suffix = '';
      if (pos !== -1) suffix = uploadData.file.name.substring(pos + 1);
      let fileBase64 = (await getBase64(uploadData.file)) as string;
      const { data: { filePath = '' } = {} } = await uploadImage({
        parkId: this.parkId || '',
        fileName: uploadData.file.name, //suffix ||
        fileBase64: fileBase64.split(',')[1],
        // @ts-ignore
        fileType: this.fileType ? this.fileType : '00'
      });
      this.fileList = [
        ...this.fileList,
        {
          uid: (this.fileList.length + 1) * -1,
          name: filePath.match(new RegExp('.+/(.+)$'))[1],
          status: UploadStatus.DONE,
          url: `${API_SERVER.imgBaseUrl}${filePath}`,
          filePath: filePath
        }
      ];
      this.$emit('on-file-change', this.fileList);
      const findUndoneIndex = this.fileList.findIndex(file => file.status !== UploadStatus.DONE);
      //const fileUrls = fileList.map(file => file.url)
      const fileUrls = this.fileList.map(file => file.filePath || '');
      if (findUndoneIndex === -1) {
        this.$emit('complete', fileUrls);
      }
    } catch (e) {
      this.$message.error((e && e.msg) || `图片上传失败`);
    } finally {
      this.uploading = false;
    }
  }
  //重置文件列表
  resetFileList(list: any = []) {
    this.fileList = list;
  }
}
